import React, { useState, useEffect } from "react";

import { Row, Column } from "components/Layout";
import Checkbox from "components/Checkbox";
import ElementModal from "./ElementModal";
import style from './_modal.module.scss';


export default function SolarSiteModal({
	isOpen, onClose, onSubmit, siteFields, freeDevices, freePlants
}) {
	const [id, setId] = useState()
	const [deviceId, setDeviceId] = useState()
	const [plantIds, setPlantIds] = useState([])
	const [capacity, setCapacity] = useState()
	const [plantSearch, setPlantSearch] = useState()
	const [mode, setMode] = useState(1)
	const [lat, setLat] = useState()
	const [lng, setLng] = useState()
	const [city, setCity] = useState("")
	const [address, setAddress] = useState("")

	useEffect(() => {
		setId(siteFields?.id)
		setPlantIds(siteFields?.plants?.map(a => a.id) || [])
		setLat(siteFields?.lat)
		setLng(siteFields?.lng)
		setCity(siteFields?.city)
		setAddress(siteFields?.address)
		setCapacity(siteFields?.capacity)
	}, [siteFields])

	function submit() {
		let submitFields = {
			id,
			deviceId,
			plantIds,
			capacity: parseFloat(capacity)
		}
		if (mode === 1) {
			submitFields = { ...submitFields, lat, lng }
		}
		if (mode === 2) {
			submitFields = { ...submitFields, city, address }
		}
		onSubmit(submitFields)
	}

	let allPlants = [ ...freePlants ]
	if (siteFields?.plants) allPlants.push(...siteFields.plants)

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} submit={submit}>
			{
				id ? (
					<Column className={style.section}>
						<Row className={style.title}>
							{`SITO ${id}`}
						</Row>
					</Column>
				) : (
					<Column className={style.section}>
						<Row className={style.title}>
							{'Associa centralina'}
						</Row>
						{
							freeDevices.map(device => <Row>
									<Checkbox
										checked={device.id === deviceId}
										onCheck={e => setDeviceId(device.id)}
									/>
									<span>{device.device}</span>
								</Row>
							)
						}
					</Column>
				)
			}
			<Column className={style.section}>
				<Row className={style.title}>
					{"Associa impianto"}
				</Row>
				<Row>
					<div className={style.title}>Ricerca per nome/ID</div>
					<input className={style.searchbar}
						type={"text"}
						placeholder={"Cerca"}
						value={plantSearch}
						onChange={e => {setPlantSearch(e.target.value);}}
					/>
				</Row>
				<div className={style.solarPlantList}>
					<table>
						<tbody>{
							allPlants
								.filter(p => {
									if (!plantSearch) return true;
									if (p.name && p.name.toLowerCase().includes(plantSearch.toLowerCase())) return true;
									if (p.uuid && p.uuid.toLowerCase().includes(plantSearch.toLowerCase())) return true;
									if (p.producerSerial && p.producerSerial.toLowerCase().includes(plantSearch.toLowerCase())) return true;
									if (p.producerId && p.producerId.toString().includes(plantSearch)) return true;
									return false;
								})
								// ordino i progetti elencando per prima i progetti assegnati, poi ordino per nome
								.sort((a, b) => {
									let assignedA = plantIds?.includes(a.id)
									let assignedB = plantIds?.includes(b.id)
									if (assignedA === true && assignedB === false)
										return -1
									else if (assignedA === false && assignedB === true)
										return 1
									else
										return a.id > b.id
								})
								.map(plant => <tr key={plant.id} className={style.freePlantRow} >
									<td>
										<Checkbox
											onCheck={e => {
												if (e.target.checked && !plantIds?.includes(plant.id)) {
													setPlantIds([...plantIds, plant.id])
												} else {
													setPlantIds(plantIds.filter(a => a !== plant.id))
												}
											}}
											checked={plantIds?.includes(plant.id)}
										/>
									</td>
									<td>{plant.id}</td>
									<td>{plant.kind}</td>
									<td>{plant.producerId || plant.producerSerial || plant.uuid}</td>
									<td>{plant.name}</td>
								</tr>)
						}</tbody>
					</table>
				</div>
				<Row className={style.fields}>
					Capacità totale (kWp)
					<input
						type={"number"}
						onChange={e => setCapacity(e.target.value)}
						value={capacity}
						step={0.1}
					/>
				</Row>
			</Column>
			<Column className={style.section}>
				<Row className={style.title}>
					Posizione geografica
				</Row>
				<Row>
					Modalità
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<label check htmlFor="geoloc-mode1">
                        <input type="radio" id="geoloc-mode1" name="geoloc-mode" value="1"
							checked={mode === 1} onChange={e => setMode(parseInt(e.target.value))}
						/> Coordinate
                    </label>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<label check htmlFor="geoloc-mode2">
                        <input type="radio" id="geoloc-mode2" name="geoloc-mode" value="2" 
							checked={mode === 2} onChange={e => setMode(parseInt(e.target.value))}
						/> Indirizzo
                    </label>
				</Row>	

				{mode === 1 && <>
					<Row className={style.fields}>
						Latitudine
						<input
							type={"number"}
							onChange={e => setLat(e.target.value)}
							value={lat}
							step={0.001}
						/>
					</Row>
					<Row className={style.fields}>
						Longitudine
						<input
							type={"number"}
							onChange={e => setLng(e.target.value)}
							value={lng}
							step={0.001}
						/>
					</Row>
				</>}

				{mode === 2 && <>
					<Row className={style.fields}>
						Città
						<input
							type={"text"}
							onChange={e => setCity(e.target.value)}
							value={city}
						/>
					</Row>
					<Row className={style.fields}>
						Indirizzo
						<input
							type={"text"}
							onChange={e => setAddress(e.target.value)}
							value={address}
						/>
					</Row>
				</>}
			</Column>
		</ElementModal>
	)
}
